import { create as createNiceModal, useModal } from '@ebay/nice-modal-react'
import { ReactElement, useCallback } from 'react'
import { SimpleModal, SimpleModalProps } from './SimpleModal'

export const CofirmationModal = createNiceModal<SimpleModalProps>(
  (props): ReactElement => {
    const modal = useModal()

    const handlePrimaryAction = useCallback(() => {
      modal.resolve(true)
      modal.hide()
    }, [modal])

    return (
      <SimpleModal
        show={modal.visible}
        primaryButtonVariant="primary"
        onPrimaryAction={() => handlePrimaryAction()}
        onSecondaryAction={() => {
          modal.resolve(false)
          modal.remove()
        }}
        {...props}
      >
        {props.children}
      </SimpleModal>
    )
  }
)
